import { render, staticRenderFns } from "./ProductVariantRow.vue?vue&type=template&id=0401e2bc&scoped=true&"
import script from "./ProductVariantRow.vue?vue&type=script&lang=ts&"
export * from "./ProductVariantRow.vue?vue&type=script&lang=ts&"
import style0 from "./ProductVariantRow.vue?vue&type=style&index=0&id=0401e2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0401e2bc",
  null
  
)

export default component.exports